import { Icon, IconButton, Typography } from '@mui/material'
import React from 'react'

import CustomTooltip from '@/app/component/atom/tooltip'

type Props = {
  contactDeleted: boolean
  contactId: number

  onClick: (contactId: number) => void
}

/**
 * This component displays a contact icon and handles the click event to view the contact details if contact ID is provided.
 */
const ContactIcon: React.FC<Props> = ({ contactDeleted, contactId, onClick }) => {
  const handleClick = () => onClick(contactId)

  if (contactDeleted) {
    return (
      <Typography color="textSecondary" variant="subtitle1">
        (contact deleted)
      </Typography>
    )
  }

  if (!contactId) {
    return (
      <Typography color="textSecondary" variant="subtitle1">
        (no contact used)
      </Typography>
    )
  }

  return (
    <CustomTooltip title={'View Contact'}>
      <IconButton aria-label="View Contact" onClick={handleClick}>
        <Icon>person</Icon>
      </IconButton>
    </CustomTooltip>
  )
}

export default ContactIcon
